import React, { forwardRef, PropsWithChildren } from "react";
import { CoordinateSystem } from "./CoordinateSystem";

interface SVGProps {
  cs: CoordinateSystem;
  className?: string;
}

export const SVG = forwardRef<SVGSVGElement, PropsWithChildren<SVGProps>>(
  ({ cs, children, className = "" }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox={`0 0 ${cs.canvasRect.width} ${cs.canvasRect.height}`}
        className={`svg-grundriss grid-fullscreen no-pointer-events-tree ${className}`}
        style={{ position: "absolute" }}
      >
        {children}
      </svg>
    );
  }
);

SVG.displayName = "SVG"; // Optional: Hilft bei der Debugging und React DevTools
